import { render, staticRenderFns } from "./addressList.vue?vue&type=template&id=aa62f272&scoped=true&"
import script from "./addressList.vue?vue&type=script&lang=js&"
export * from "./addressList.vue?vue&type=script&lang=js&"
import style0 from "./addressList.vue?vue&type=style&index=0&id=aa62f272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa62f272",
  null
  
)

export default component.exports